import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleMaps = defineConnector({
  identifier: "googleMaps",
  name: "Google Maps",
  tagLine: "Mapping and geocoding services",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://maps\\.googleapis\\.com/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Find your Google Maps API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Google Maps API key guide](https://developers.google.com/maps/documentation/javascript/get-api-key) and create an API key in Google Cloud Console. Restrict the key to the Maps APIs and project you want to use before you copy it.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Google Maps account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "AIzaSyAY4P9A***************1YMSYBI",
          helperText: "Your Google Maps API Key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA",
  },
});
